export const NOT_FOUND_TAG_NAME = 'not-found';
